exports.baseURL = "https://ajobfun.cloud/";
exports.key = "BS67Rfb0Tf";
exports.projectName = "Ajobfun";
